// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3bJ6Y","col":"CardReaderDesc_col__2iqvs","label":"CardReaderDesc_label__3O0w0"};